import intlTelInput from 'intl-tel-input';

const phoneInputsWrappers = document.querySelectorAll('.form-phone');

if (phoneInputsWrappers.length > 0) {
    const formCheckout = document.querySelector('form.js-phone-prefix');
    const billingCountry = formCheckout
        ? formCheckout.querySelector("[name='billing_country']")
        : null;

    phoneInputsWrappers.forEach(element => {
        const input = element.querySelector('.form-phone__input');
        const hiddenInput = element.querySelector('.form-phone__hidden-input');
        const validInput = element.querySelector('[name="has_been_validated"]');
        const parent = input.parentElement.parentElement;

        const intTelInputInstance = intlTelInput(input, {
            initialCountry: billingCountry
                ? billingCountry.options[billingCountry.selectedIndex].value
                : 'pl',
            separateDialCode: true,
            strictMode: true,
            utilsScript: '../../../../../node_modules/intl-tel-input/build/js/utils.js',
            countryOrder: ['gb', 'us', 'pl'],
        });

        if (billingCountry) {
            input.addEventListener('countrychange', () => handleCountry());

            billingCountry.parentElement.addEventListener(
                'onSelectChange',
                e => {
                    const { value } = e.detail;

                    intTelInputInstance.setCountry(value.toLowerCase());
                }
            );
        }

        if (input.value.length > 0) parent.classList.add('-typing');

        input.addEventListener('focus', e => {
            parent.classList.add('-typing');
        });

        input.addEventListener('blur', e => {
            const value = e.target.value;

            if (value.length === 0) parent.classList.remove('-typing');
        });

        input.addEventListener('input', e => {
            const inputValue = e.target.value;
            const countryCode =
                intTelInputInstance.selectedCountryData.dialCode;

            if (inputValue.length < 1) {
                hiddenInput.value = '';
            } else {
                hiddenInput.value = '+' + countryCode + inputValue;
            }

            handleValidInput();
        });

        input.addEventListener('countrychange', e => {
            const inputValue = e.target.value;
            const countryCode =
                intTelInputInstance.selectedCountryData.dialCode;
            hiddenInput.value = '+' + countryCode + inputValue;
            handleValidInput();
        });

        document.addEventListener('DOMContentLoaded', () => {
            const countryCode =
                intTelInputInstance.selectedCountryData.dialCode;
            const inputValue = input.value;
            const regex = new RegExp(
                `\\+${countryCode}|00${countryCode}|-`,
                'g'
            );
            const inputValueToSet = inputValue.replace(regex, '');
            input.value = inputValueToSet;
            hiddenInput.value = '+' + countryCode + inputValueToSet;
        });

        intTelInputInstance.promise.then(() => {
            handleCountry();
            document.addEventListener("DOMContentLoaded", () => {
                handleValidInput();
            })
        })

        const handleCountry = () => {
            const { iso2 } = intTelInputInstance.getSelectedCountryData();
            const optionToSelect = Array.from(billingCountry.options).find(
                option => option.value === iso2.toUpperCase()
            );

            if (optionToSelect) optionToSelect.selected = true;
            billingCountry.dispatchEvent(new Event('change'));
        }

        const handleValidInput = () => {
            if (!validInput) return;
            if (intTelInputInstance.isValidNumberPrecise()) {
                validInput.value = '1';
            } else {
                validInput.value = '0';
            }
        };
    });
}
